export const SEVERITY_CRITICAL = 'critical';
export const SEVERITY_INFO = 'info';
export const SEVERITY_WARNING = 'warning';

export const SEVERITIES = [SEVERITY_CRITICAL, SEVERITY_INFO, SEVERITY_WARNING];

export const TEMPLATE_TYPE = 'template';
export const TEMPLATE_WEATHER_TYPE = 'template-weather';

export const friendlyRuleNameMap = new Map([
  [TEMPLATE_TYPE, 'Signal'],
  [TEMPLATE_WEATHER_TYPE, 'Weather'],
]);

export function ruleTypeFriendlyName(type) {
  return friendlyRuleNameMap.get(type) ?? 'Unknown';
}
